import { gql, TypedDocumentNode } from "@apollo/client";

import { AiIntegration, MutationAiIntegrationDeleteArgs } from "types/generated";

export const DELETE_AI_INTEGRATION: TypedDocumentNode<
  {
    aiIntegrationDelete: Pick<AiIntegration, "id">;
  },
  MutationAiIntegrationDeleteArgs
> = gql`
  mutation DeleteAiIntegration($id: ID!) {
    aiIntegrationDelete(id: $id) {
      id
    }
  }
`;
